/* eslint-disable */
export default {
    competencies_competency_development_oriented: "Orientation développement",
    competencies_competency_attentive_listening: "Écouter attentivement",
    competencies_competency_adaptability: "Capacité d'adaptation",
    competencies_competency_direction: "Piloter",
    competencies_competency_analytical_capabilities: "Capacité d'analyse",
    competencies_competency_autonomy: "Autonomie",
    competencies_competency_accompaniment: "Accompagnement",
    competencies_competency_resolution: "Dynamisme",
    competencies_competency_collaboration_promotion: "Promouvoir la coopération",
    competencies_competency_coaching: "Coaching",
    competencies_competency_collegiality: "Collégialité",
    competencies_competency_commercial_drive: "Dynamisme commercial",
    competencies_competency_communicative_flexibility: "Flexibilité communicative",
    competencies_competency_decisiveness_competencies: "Capacité de décision",
    competencies_competency_delegation: "Déléguer",
    competencies_competency_persistent_questioning: "Continuer à poser des questions",
    competencies_competency_work_efficiency: "Travailler efficacement",
    competencies_competency_kindle_enthusiasm: "Enthousiasmer",
    competencies_competency_external_orientation: "Orientation externe",
    competencies_competency_financial_insight: "Connaissances financières",
    competencies_competency_flexibility: "Flexibilité",
    competencies_competency_improvisation: "Improviser",
    competencies_competency_initiative: "Initiative",
    competencies_competency_innovative_thinking: "Pensée innovante",
    competencies_competency_integrity: "Intégrité",
    competencies_competency_interpersonal_sensitivity: "Sensibilité interpersonnelle",
    competencies_competency_effort: "Engagement ",
    competencies_competency_client_orientation: "Orientation client",
    competencies_competency_quality_orientation: "Orientation qualité",
    competencies_competency_oral_communication: "Communication orale",
    competencies_competency_exactness: "Précision",
    competencies_competency_judgement: "Jugement",
    competencies_competency_openness_to_change: "Ouvert(e) au changement",
    competencies_competency_organisation_sensitivity: "Sensibilité organisationnelle",
    competencies_competency_persuasiveness: "Persuasion",
    competencies_competency_planning_and_organisation: "Planifier et organiser",
    competencies_competency_practicality: "Agir de façon pratique",
    competencies_competency_problem_solving_capability: "Capacité de résolution de problèmes",
    competencies_competency_arithmetic_proficiency: "Compétences en mathématiques",
    competencies_competency_managing_relationships: "Gestion des relations",
    competencies_competency_results_orientation: "Orientation résultats",
    competencies_competency_written_communication: "Communiquer par écrit",
    competencies_competency_service_orientation: "Orientation service",
    competencies_competency_social_versatility: "Flexibilité sociale",
    competencies_competency_firmness: "Ténacité",
    competencies_competency_stress_resistance: "Résistance au stress",
    competencies_competency_tact: "Tact",
    competencies_competency_explanation_and_clarification_skills: "Expliquer et clarifier",
    competencies_competency_expertise: "Compétence",
    competencies_competency_tenacity: "Persévérance",
    competencies_competency_sense_of_responsibility: "Sens des responsabilités",
    competencies_competency_ingenuity: "Ingéniosité",
    competencies_competency_vision: "Vision",
    competencies_competency_monitoring: "Suivi de l'avancement",
    competencies_competency_carefulness: "Minutie",
    report_conformity: "Se conformer",
    report_independence: "Indépendant",
    report_altruism: "Altruisme",
    report_leadership: "Diriger",
    report_support_and_recognition: "Soutien et reconnaissance",
    report_materialism: "Matérialisme",
    report_indulgence: "Indulgence",
    report_general_ability: "Intelligence générale",
    competencies_competency_inclusivity: "Inclusivité",
    persona_fit_role_to_be_go_getter: "Fonceur",
    persona_fit_role_to_be_expert: "Spécialiste",
    persona_fit_role_to_be_controller: "Moniteur",
    persona_fit_role_to_be_coordinator: "Coordinateur",
    persona_fit_role_to_be_connector: "Rassembleur",
    persona_fit_role_to_be_inspirator: "Motivateur",
    persona_fit_role_to_be_innovator: "Innovateur",
    persona_fit_role_to_be_entrepreneur: "Entrepreneur",
    abstractAbility: "Intelligence abstraite",
    verbalAbility: "Intelligence verbale",
    numericalAbility: "Intelligence numérique",
    oprecht: "Direct(e)",
    Extraversie: "Extraversion",
    "Emotionele.stabiliteit": "Stabilité émotionnelle",
    "Openheid.van.geest": "Ouverture d’esprit",
    Conscientieusheid: "Esprit méticuleux",
    "Behoefte.aan.affiliatie": "Besoin de solidarité",
    "Behoefte.aan.autonomie": "Besoin d’autonomie",
    "Behoefte.aan.macht": "Besoin de pouvoir",
    "Behoefte.aan.prestatie": "Besoin de performances",
    Berekenend: "Anticipatif",
    Assertief: "Affirmation de soi",
    Manipulatief: "Socialement adroit(e)",
    Rechtdoorzee: "Franc et honnête",
    Doortastend: "Est énergique",
    "Extrinsieke.prestatiemotivatie": "Aspire à la réussite",
    "Intrinsieke.prestatiemotivatie": "Aspire à la qualité",
    "Negatieve.faalangst": "Incertitude sur les performances",
    Ontwikkelingsgericht: "Se concentre sur le développement",
    "Positieve.faalangst": "Besoin de défis",
    Behulpzaamheid: "Serviabilité",
    Dominantie: "Dominance",
    Nuchterheid: "Réalisme",
    "Onafhankelijk.denken": "Penser de manière autonome",
    Optimisme: "Optimisme",
    "Relationele.stressbestendigheid": "Résistance au stress relationnel",
    "Taakgerelateerde.stressbestendigheid": "Tolérance au stress lié à la tâche",
    Sociabiliteit: "Sociabilité",
    "Systematisch.werken": "Travailler de manière méthodique",
    Veranderingsgericht: "Axé(e) sur le changement",
    Verantwoordelijkheid: "Responsabilité",
    Verbeelding: "Imagination",
    Vertrouwen: "Confiance",
    Vriendelijkheid: "Amabilité",
    Zelfdiscipline: "Autodiscipline",
    agility: "Résilience",
    energy: "Énergie",
    growthMindset: "État d’esprit de développement",
    selfManagement: "Autogestion",
    Proud: "Fier/fière",
    willingnessToTakeRisks: "Appétit pour le risque",
    attention_emotionele_stabiliteit_3_extraversie_3_vriendelijkheid_3: "Tenir compte des hésitations des autres",
    hexit_explosief: "Temperamental",
    hexit_meedogenloos: "Inexorable",
    hexit_egocentrisch: "Égocentrique",
    hexit_machiavellistisch: "Rusé",
    hexit_rigoureus: "Indépendant",
    hexit_micromanager: "Contrôlant",
    hexit_perfectionistisch: "Perfectionniste",
    hexit_autopiloot: "Rigide",
    hexit_behoedzaam: "Prudent",
    hexit_lichtzinnig: "Nonchalant",
    hexit_chaotisch: "Chaotique",
    hexit_roekeloos: "Téméraire",
    hexit_afstandelijk: "Distant",
    hexit_koppig: "Têtu",
    hexit_cynisch: "Cynique",
    hexit_passiefAgressief: "Subversif",
    hexit_volgzaam: "Docile",
    hexit_theatraal: "Théâtral",
    hexit_paranoide: "Critique",
    hexit_anarchistisch: "Rebelle",
    competencies_competency_intellectual_capability: "Capacité intellectuelle",
    cp_talent_analytics_title: "Talent analytics",
    cp_talent_analytics_chosen_filters: "Filtres choisis:",
    cp_talent_analytics_empty_title: "Aucun rapport de groupe pour l'instant",
    cp_talent_analytics_empty_text: "Il n’y a pas (encore) de rapports de groupe. Enregistrez votre premier tableau de bord dans l'aperçu des participants pour voir votre rapport de groupe ici.",
    cp_talent_analytics_empty_redirect_button: "Vers l'aperçu des participants",
    cp_talent_analytics_empty_instruction_title: "Comment fonctionnent les rapports de groupe ?",
    cp_talent_analytics_empty_instruction_text: "Ici vous voyez comment fonctionne le flux lors de la demande d'un rapport de groupe",
    cp_talent_analytics_empty_instruction_step_one: "Sélectionnez le(s) groupe(s) de personnes dans l'aperçu des participants qui doivent figurer dans votre rapport de groupe.",
    cp_talent_analytics_empty_instruction_step_two: "Ouvrez le tableau de bord souhaité (tableau de bord de gestion, classement ou tableau de bord de culture)",
    cp_talent_analytics_empty_instruction_step_three: "Enregistrez le tableau de bord pour les afficher ici",
    cp_talent_analytics_empty_instruction_step_four: "Accédez au rapport de votre groupe pour voir les résultats",
    cp_talent_analytics_recent_reports_title: "Rapport(s) récent(s)",
    cp_talent_analytics_recent_reports_subtitle: "Vous trouverez ici les rapports de groupe les plus récents.",
    cp_talent_analytics_other_reports_title: "Autre(s) rapport(s)",
    cp_talent_analytics_other_reports_subtitle: "Dans la liste ci-dessous vous trouverez tous les autres rapports de groupe.",
    cp_talent_analytics_recent_reports_view_button: "Voir",
    cp_talent_analytics_no_filters_selected: "Aucun filtre sélectionné",
    cp_participants_dashboards_title_toxics: "",
    cp_talent_analytics_search: "Recherche...",
    cp_talent_analytics_group_type_filter: "Type de rapport",
    cp_talent_analytics_previous_page: "Précédent",
    cp_talent_analytics_next_page: "Suivant",
    cp_talent_analytics_back_to_overview: "Retour à l'aperçu de Talent Analytics",
    cp_talent_analytics_share_report_modal_title: "Partager le rapport",
    cp_talent_analytics_share_report_modal_text: "Sélectionnez les personnes avec lesquelles vous souhaitez partager le rapport. Vous pouvez sélectionner un utilisateur existant ou en ajouter un nouveau. Les personnes que vous sélectionnez recevront un e-mail pour les en informer.",
    cp_talent_analytics_share_report_modal_add_new_user_button: "Nouvel utilisateur",
    cp_talent_analytics_add_new_user_modal_title: "Créer un nouvel utilisateur pour",
    cp_talent_analytics_add_new_user_modal_text: "Fournissez ici les détails d’un utilisateur qui a besoin d’accéder au rapport de groupe.",
    cp_talent_analytics_add_new_user_modal_save_button: "Enregistrer et inviter un utilisateur",
    cp_talent_analytics_add_new_user_modal_select_user: "Sélectionner l’utilisateur",
    cp_talent_analytics_add_new_user_modal_select_add_new: "Ajouter un nouvel utilisateur",
    cp_talent_analytics_share_report_modal_display_users_title: "Ce rapport est partagé avec :",
    cp_talent_analytics_share_report_modal_display_users_owner: "Créateur/ propriétaire",
    cp_talent_analytics_share_report_modal_display_users_can_view: "Peut voir",
    cp_talent_analytics_share_report_button: "Partager",
    cp_talent_analytics_share_report_modal_display_users_remove_button: "Retirer",
    cp_talent_analytics_share_report_modal_select_placeholder: "Commencez par taper le nom de l'utilisateur...",
    cp_talent_analytics_remove_access_modal_title: "Supprimer l’accès au rapport",
    cp_talent_analytics_remove_access_modal_text: "Cela signifie qu’il/elle ne verra plus ce rapport dans son aperçu et qu’il ne pourra pas l’ouvrir à partir d’un lien ou d’une autre manière. Êtes-vous sûr de vouloir révoquer l’accès ?",
    cp_talent_analytics_remove_access_modal_remove_button: "Supprimer l’accès",
    cp_talent_analytics_remove_access_modal_cancel_button: "Annuler",
    cp_talent_analytics_remove_access_modal_text_with_name: "Vous allez supprimer l’accès à ce rapport pour",
    cp_talent_analytics_detail_empty_title: "Ce rapport de groupe n'existe pas ou vous n'êtes pas autorisé à le consulter.",
    cp_talent_analytics_detail_empty_text: "Accédez à la vue d’ensemble de l’analyse des talents pour voir les rapports de groupe qui existent et auxquels vous avez accès.",
    cp_talent_analytics_detail_empty_redirect_button: "Vers l’analyse des talents",
    cp_talent_analytics_share_report_modal_display_users_empty: "Vous ne partagez pas encore ce rapport avec quelqu'un d'autre.",
    cp_talent_analytics_share_report_modal_add_access_success_message: "Une notification a été envoyée à l’utilisateur",
    cp_talent_analytics_share_report_modal_invite_user_success_message: "L’invitation est envoyée",
    cp_talent_analytics_share_report_modal_remove_user_success_message: "L’accès est supprimé",
    cp_talent_analytics_no_feature_empty_title: "Vous n'avez pas accès à la vue d'ensemble et aux outils de Talent Analytics",
    cp_talent_analytics_no_feature_empty_text: "Pour en savoir plus sur cette vue d’ensemble et sur la possibilité de Talent Analytics, cliquez sur le bouton ci-dessous",
    cp_talent_analytics_no_feature_empty_redirect_button: "Plus d'informations",
    cp_talent_analytics_new_group_report: "New group report",
    cp_talent_analytics_create_new_modal_step1_title: "Step 1: What kind of report do you want?",
    cp_talent_analytics_create_new_modal_step2_title: "Step 2: Which people should be included in the report?",
    cp_talent_analytics_create_new_modal_select_type_title: "Which type of report do you want to create?",
    cp_talent_analytics_create_new_modal_name_title: "What is the name of the report?",
    cp_talent_analytics_create_new_modal_name_placeholder: "Name of the report",
    cp_talent_analytics_create_new_modal_step2_body: "Select the group(s) you want to include",
    cp_talent_analytics_create_new_modal_search_groups_placeholder: "Search groups",
    cp_talent_analytics_create_new_modal_selected_groups: "Selected groups",
    cp_talent_analytics_create_new_modal_button_create_report: "Create report",
    cp_talent_analytics_create_new_modal_button_cancel: "Cancel",
    cp_talent_analytics_create_new_modal_button_back: "Back",
    cp_talent_analytics_create_new_modal_button_select_groups: "Select groups",
    cp_talent_analytics_create_new_group_report_error: "Something went wrong while creating the new group report, please try again later.",
    cp_talent_analytics_create_new_group_report_success: "The group report was successfully created.",
    cp_talent_analytics_fetch_available_groups_error: "Something went wrong while fetching available groups, please try again later.",
    cp_talent_analytics_share_report_modal_warning: "Lorsque vous partagez ce rapport de groupe, le destinataire peut voir toutes les informations contenues dans le rapport. Assurez-vous que la personne que vous invitez a le droit de voir les informations contenues dans le rapport de groupe.",
    cp_talent_analytics_share_report_modal_add_new_user_without_select_button: "Inviter l’utilisateur à consulter ce rapport de groupe",
    cp_talent_analytics_loading_chip: "Chargement...",
    cp_participants_dashboards_label_you: "",
    cp_participants_dashboards_label_positive_predictors_intro00: "",
    cp_participants_dashboards_label_positive_predictors_intro01: "",
    cp_participants_dashboards_label_positive_predictors_intro02: "",
    cp_participants_dashboards_label_positive_predictors_intro03: "",
    cp_participants_dashboards_label_positive_predictors_list1: "",
    cp_participants_dashboards_label_group_1: "",
    cp_participants_dashboards_label_group_2: "",
    cp_participants_dashboards_prediction_percentage_left1: "",
    cp_participants_dashboards_prediction_percentage_left2: "",
    cp_participants_dashboards_prediction_percentage_left3: "",
    cp_participants_dashboards_prediction_percentage_left4: "",
    cp_participants_dashboards_prediction_percentage_right1: "",
    cp_participants_dashboards_prediction_percentage_right2: "",
    cp_participants_dashboards_prediction_percentage_right3: "",
    cp_participants_dashboards_prediction_percentage_right4: "",
    cp_participants_dashboards_label_group_characteristics: "",
    cp_participants_dashboards_label_group_border: "",
    cp_participants_dashboards_applicant_prediction_label: "",
    cp_participants_dashboards_label_ml_outcome0: "",
    cp_participants_dashboards_label_ml_outcome1: "",
    cp_participants_dashboards_label_ml_outcome2: "",
    cp_participants_dashboards_label_ml_outcome3: "",
    cp_participants_dashboards_label_ml_outcome4: "",
    cp_participants_dashboards_label_ml_outcome5: "",
    cp_participants_dashboards_label_ml_applicants_intro: "",
    cp_participants_dashboards_label_ml_applicants_explanation1: "",
    cp_participants_dashboards_label_ml_applicants_explanation2: "",
    cp_participants_dashboards_title_group_membership_prediction_start: "",
    cp_participants_dashboards_title_group_membership_prediction_predictors_result: "",
    cp_participants_dashboards_title_group_membership_prediction_model_applied_members_result: "",
    cp_participants_dashboards_title_group_membership_prediction_model_performance_result: "",
    cp_participants_dashboards_title_group_membership_prediction_model_applied_applicants_result: "",
    cp_participants_dashboards_label_ml_members_explanation1: "",
    cp_participants_dashboards_label_ml_members_explanation2: "",
    cp_participants_dashboards_label_ml_members_intro: "",
    cp_participants_dashboards_label_negative_predictors_list2: "",
    cp_participants_dashboards_label_group_jobgroup_fit_prediction: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit: "",
    cp_participants_dashboards_label_group_jobgroup_fit_not: "",
    cp_participants_dashboards_prediction_prevalences_0: "",
    cp_participants_dashboards_prediction_prevalences_1: "",
    cp_participants_dashboards_prediction_prevalences_2: "",
    cp_participants_dashboards_prediction_prevalences_3: "",
    cp_participants_dashboards_prediction_prevalences_legend_name: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_beleid_organisatie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_beveiliging_en_bewaking: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_facilitaire_zaken: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_gezondheid: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_inkoop: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_productie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_kwaliteitscontrole_veiligheid: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_logistiek_transport_vervoer: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_management_business: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_marketing: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onderwijs_training: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onderzoek_wetenschap: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_sales_verkoop: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_technisch: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_executive: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_bouwnijverheid: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_cultuur_sport_en_recreatie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_energievoorziening: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_financiele_dienstverlening: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_gezondheids_en_welzijnszorg: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_kandel: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_koreca: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_industrie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_informatie_en_communicatie: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_landbouw_bosbouw_en_visserij: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onderwijs: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_onroerend_goed_verhuur_en_handel: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_openbaar_bestuur_en_overheidsdiensten: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_overige_dienstverlening: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_specialistische_zakelijke_diensten: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_verhuur_en_overige_zakelijke_diensten: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_vervoer_en_opslag: "",
    cp_participants_dashboards_title_group_membership_prediction_benchmark_fit_waterbedrijven_en_afvalbeheer: "",
    cp_participants_dashboards_prediction_related_competencies_intro: "",
    cp_participants_dashboards_prediction_related_competencies_are: "",
    cp_participants_dashboards_prediction_related_competencies_legend_name: "",
    cp_participants_dashboards_legend_age55plus: "",
    cp_participants_dashboards_legend_show_benchmark: "",
    cp_participants_dashboards_benchmark_comparision_norm_group: "",
    cp_participants_dashboards_benchmark_more_than_one_group: "",
    cp_participants_dashboards_recalculation_warning: "",
    cp_participants_dashboards_title_lasso_calculated_main_profile_of_group: "",
    cp_participants_dashboards_related_competencies_not_clear: "",
    cp_participants_dashboards_no_profile_can_be_calculated: "",
    cp_participants_dashboards_these_are_low_competency_scores: "",
    cp_participants_dashboards_there_are_no_low_competency_scores: "",
    cp_talent_analytics_settings_status_draft: "Draft",
    cp_talent_analytics_settings_status_published: "Published",
    cp_talent_analytics_settings_button_open_report: "Open",
    cp_talent_analytics_settings_form_section_report_title: "Report details",
    cp_talent_analytics_settings_form_section_report_description: "Here you can find all the settings for this report. Things like which report it is and how certain elements in the report are displayed",
    cp_talent_analytics_settings_form_section_settings_title: "Settings",
    cp_talent_analytics_settings_form_section_settings_description: "Here you can find all the settings for this report. Things like which report it is and how certain elements in the report are displayed.",
    cp_talent_analytics_settings_form_field_report_name: "Name of the report",
    cp_talent_analytics_settings_form_field_report_type: "Type of the report",
    cp_talent_analytics_settings_form_field_report_type_option_basic: "Basic",
    cp_talent_analytics_settings_form_field_report_type_option_basic_description: "A basic report that shows the most important information.",
    cp_talent_analytics_settings_form_field_report_type_option_team: "Team",
    cp_talent_analytics_settings_form_field_report_type_option_team_description: "A report that shows the performance of a team.",
    cp_talent_analytics_settings_form_field_report_type_option_ranking: "Ranking",
    cp_talent_analytics_settings_form_field_report_type_option_ranking_description: "A report that shows a ranking of participants of a selection assessment",
    cp_talent_analytics_settings_form_field_report_type_option_other: "Other",
    cp_talent_analytics_settings_form_field_report_type_option_other_description: "A report that shows other information.",
    cp_talent_analytics_settings_form_field_report_type_option_lasso: "Lasso",
    cp_talent_analytics_settings_form_field_report_type_option_lasso_description: "A report that shows the performance of a team.",
    cp_talent_analytics_settings_form_field_report_type_option_benchmark: "Benchmark",
    cp_talent_analytics_settings_form_field_report_type_option_benchmark_description: "A report that shows the performance of a team.",
    cp_talent_analytics_settings_form_field_report_published: "Published",
    cp_talent_analytics_settings_form_field_report_published_description: "When the report is published, it is visible to everyone who has access to the report.",
    cp_talent_analytics_settings_form_unsaved: "Your changes have not yet been saved",
    cp_talent_analytics_settings_form_saved: "Your changes have been saved",
    cp_talent_analytics_settings_form_button_save: "Save",
    cp_participants_dashboards_title_main_intro_teamsession: "",
    cp_participants_dashboards_title_culture_intro_teamsession: "",
    cp_participants_dashboards_title_dynamics_intro_teamsession: "",
    cp_participants_dashboards_title_roles_intro_teamsession: "",
    cp_participants_dashboards_no_positive_predictors_available: "",
    cp_participants_dashboards_mainIntroText1: "",
    cp_participants_dashboards_mainIntroText2: "",
    cp_participants_dashboards_mainIntroText21: "",
    cp_participants_dashboards_mainTntroText22: "",
    cp_participants_dashboards_mainIntroText23: "",
    cp_participants_dashboards_cultureIntroText: "",
    cp_participants_dashboards_groupDynamicsIntroText: "",
    cp_participants_dashboards_rolesIntroText: "",
    cp_participants_dashboards_label_negative_predictors_main_profile: "",
    cp_participants_dashboards_label_positive_predictors_main_profile: "",
    cp_talent_analytics_settings_form_section_groups_title: "",
    cp_talent_analytics_settings_form_section_groups_description: "",
    cp_talent_analytics_settings_form_group_edit_description: "",
    cp_talent_analytics_settings_form_group_edit_about_this_group: "",
    cp_talent_analytics_settings_form_group_edit_remove_member: "",
    cp_talent_analytics_settings_form_group_edit_subtitle: "",
    cp_talent_analytics_settings_form_group_edit_search_members: "",
    cp_talent_analytics_settings_form_group_edit_no_members_title: "",
    cp_talent_analytics_settings_form_group_edit_no_members_subtitle: "",
    cp_participants_dashboards_label_control_culture2: "",
    cp_participants_dashboards_label_innovation_culture2: "",
    cp_participants_dashboards_label_harmony_culture2: "",
    cp_participants_dashboards_label_result_culture2: "",
    cp_participants_dashboards_label_autonomous_self_management2: "",
    cp_participants_dashboards_label_docile_self_management2: "",
    cp_participants_dashboards_label_confident_self_management2: "",
    cp_participants_dashboards_label_self_criticism_self_management2: "",
    cp_participants_dashboards_label_conservative_innovation_power2: "",
    cp_participants_dashboards_label_progressive_innovation_power2: "",
    cp_participants_dashboards_label_decisiveness_innovation_power2: "",
    cp_participants_dashboards_label_thoughtful_innovation_power2: "",
    cp_participants_dashboards_label_socially_compliant_communication_styles2: "",
    cp_participants_dashboards_label_socially_resilient_communication_styles2: "",
    cp_participants_dashboards_label_candid_communication_styles2: "",
    cp_participants_dashboards_label_diplomatic_communication_styles2: "",
    cp_participants_dashboards_label_little_focus_self_interest_conflict_management2: "",
    cp_participants_dashboards_label_strong_focus_self_interest_conflict_management2: "",
    cp_participants_dashboards_label_little_focus_on_relationship_conflict_management: "",
    cp_participants_dashboards_label_strong_focus_on_relationship_conflict_management2: "",
    cp_participants_dashboards_important_percentages: "",
    cp_participants_dashboards_less_important_percentages: "",
    cp_participants_dashboards_roles_highest_avarage_scores: "",
    cp_participants_dashboards_roles_lowest_avarage_scores: "",
    cp_participants_dashboards_show_chart_explantion_text: "",
    cp_participants_dashboards_dominance_distribution_equal: "",
    cp_participants_dashboards_dominance_distribution_lower: "",
    cp_participants_dashboards_dominance_distribution_higher: "",
    cp_participants_dashboards_culturechart1_chartexplanation: "",
    cp_participants_dashboards_culturechart2_chartexplanation: "",
    cp_participants_dashboards_dominancepyramid_chartexplanation: "",
    cp_participants_dashboards_selfmanagement_chartexplanation: "",
    cp_participants_dashboards_communicationstyles_chartexplanation: "",
    cp_participants_dashboards_innovationpower_chartexplanation: "",
    cp_participants_dashboards_conflictmanagement_chartexplanation: "",
    cp_participants_dashboards_short_summary_intro: "",
    cp_participants_dashboards_dominance_distribution_higher_shortsummary: "",
    cp_participants_dashboards_dominance_distribution_lower_shortsummary: "",
    cp_participants_dashboards_dominance_distribution_labourmarket_shortsummary: "",
    cp_participants_dashboards_dominance_distribution_equal_shortsummary: "",
    cp_participants_dashboards_number_of_participants_shortsummary: "",
    cp_participants_dashboards_shortsummary_main_culture: "",
    cp_talent_analytics_settings_form_field_show_all_charts: "",
    cp_talent_analytics_settings_form_field_show_all_charts_description: "",
    cp_talent_analytics_settings_form_field_show_initials: "",
    cp_talent_analytics_settings_form_field_show_initials_description: "",
    cp_talent_analytics_settings_form_field_show_names: "",
    cp_talent_analytics_settings_form_field_show_names_description: "",
    cp_talent_analytics_settings_form_field_show_names_to_ltp: "",
    cp_talent_analytics_settings_form_field_show_names_to_ltp_description: "",
    cp_participants_dashboards_label_little_focus_on_relationship_conflict_management2: "",
    cp_participants_dashboards_toxics_lowest_avarage_scores: "",
    cp_participants_dashboards_toxics_highest_avarage_scores: "",
    cp_participants_dashboards_toxicsIntroText: "",
    cp_participants_dashboards_title_intro_benchmark: "",
    cp_participants_dashboards_title_toxics_intro_teamsession: "",
    cp_participants_dashboards_mainIntroText2_boardscan: "",
    cp_talent_analytics_create_new_modal_available_groups: "",
    cp_talent_analytics_create_new_modal_step1_description: "",
    cp_talent_analytics_create_new_modal_step2_description: "",
    cp_participants_dashboards_benchmarkIntroText: "",
    cp_participants_dashboards_label_group_jobgroup_fit_with: "",
    cp_participants_dashboards_total_group_name: "",
    cp_participants_dashboards_status_group_hired: "",
    cp_participants_dashboards_status_group_non_hired: "",
    cp_participants_dashboards_status_group_in_consideration: "",
    cp_participants_dashboards_groupreportname_organisation_analysis_culture_insights: "",
    cp_participants_dashboards_reflection_summary: "",
    cp_participants_dashboards_reflection_total_number_of_texts: "",
    cp_participants_dashboards_reflection_neutral: "",
    cp_participants_dashboards_reflection_positive: "",
    cp_participants_dashboards_reflection_negative: ""
};
